/**
 * Sync opt-in mount & balance service line items when cart contains opted-in tires.
 * Fee quantity = one per set of 4 tires (ceil(tireQty / 4)), grouped by rim diameter.
 */
(function () {
  const TIRE_TYPE = 'Tire';
  const AUTO_PROP = '_auto';
  const AUTO_VALUE = 'tire_mount_balance';
  const PROP_INCLUDE = '_include_mount_balance';
  const PROP_RIM = '_mount_rim';
  const RIM_PROP = '_rim';
  const FORM_IDS = ['cart', 'CartDrawer-Form', 'cart-notification-form'];
  const FEE_PRODUCT_HANDLE = 'mount-balance-service';

  let syncPromise = null;
  let resolvedConfigPromise = null;

  function mountSetCount(tireQty) {
    var q = Number(tireQty) || 0;
    if (q <= 0) return 0;
    return Math.ceil(q / 4);
  }

  function readConfig() {
    var el = document.getElementById('tire-mount-balance-fee-config');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function buildVariantMapFromProduct(product) {
    var map = {};
    var fallbackId = '';
    if (!product || !product.variants) return { variantByRim: map, fallbackVariantId: fallbackId };

    product.variants.forEach(function (v) {
      if (!v || !v.id) return;
      var rim = '';
      if (v.option1) rim = String(v.option1).trim();
      else if (v.title) rim = String(v.title).trim();
      if (rim === 'Default' || rim === '') {
        fallbackId = String(v.id);
      } else {
        map[rim] = String(v.id);
      }
    });

    if (!fallbackId && product.variants[0]) {
      fallbackId = String(product.variants[0].id);
    }

    return { variantByRim: map, fallbackVariantId: fallbackId };
  }

  function resolveConfig() {
    if (resolvedConfigPromise) return resolvedConfigPromise;

    var base = readConfig();
    if (!base || !base.enabled) {
      resolvedConfigPromise = Promise.resolve(null);
      return resolvedConfigPromise;
    }

    var variantByRim = base.variantByRim && typeof base.variantByRim === 'object' ? base.variantByRim : {};
    if (typeof variantByRim === 'string') {
      try {
        variantByRim = JSON.parse(variantByRim);
      } catch (e) {
        variantByRim = {};
      }
    }

    var fallbackVariantId = String(base.fallbackVariantId || '').trim();
    var hasMap = Object.keys(variantByRim).length > 0;

    if (fallbackVariantId && hasMap) {
      resolvedConfigPromise = Promise.resolve(
        Object.assign({}, base, { variantByRim: variantByRim, fallbackVariantId: fallbackVariantId })
      );
      return resolvedConfigPromise;
    }

    var handle = base.productHandle || FEE_PRODUCT_HANDLE;
    resolvedConfigPromise = fetch('/products/' + handle + '.json', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data || !data.product) return null;
        var built = buildVariantMapFromProduct(data.product);
        return Object.assign({}, base, {
          variantByRim: hasMap ? variantByRim : built.variantByRim,
          fallbackVariantId: fallbackVariantId || built.fallbackVariantId,
        });
      })
      .catch(function () {
        return fallbackVariantId
          ? Object.assign({}, base, { variantByRim: variantByRim, fallbackVariantId: fallbackVariantId })
          : null;
      });

    return resolvedConfigPromise;
  }

  function getCheckoutUrl() {
    return (window.routes && window.routes.checkout_url) || '/checkout';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function cartChange(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('change');
      return r.json();
    });
  }

  function cartAdd(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    });
  }

  function isOptInTireLine(item) {
    if (!item) return false;
    if ((item.product_type || '').trim() !== TIRE_TYPE) return false;
    var props = item.properties || {};
    return props[PROP_INCLUDE] === 'true';
  }

  function isAutoMountLine(item) {
    if (!item) return false;
    var props = item.properties || {};
    return props[AUTO_PROP] === AUTO_VALUE;
  }

  function rimKeyFromTireLine(item) {
    var props = item.properties || {};
    var rim = String(props[PROP_RIM] || '').trim();
    return rim || 'fallback';
  }

  function rimKeyFromMountLine(item) {
    var props = item.properties || {};
    return String(props[RIM_PROP] || 'fallback').trim() || 'fallback';
  }

  function variantIdForRim(config, rimKey) {
    var map = config.variantByRim || {};
    if (rimKey && rimKey !== 'fallback' && map[rimKey]) {
      return parseInt(String(map[rimKey]), 10);
    }
    return parseInt(String(config.fallbackVariantId), 10);
  }

  function requiredMountByRim(cart) {
    var byRim = {};
    (cart.items || []).forEach(function (item) {
      if (!isOptInTireLine(item)) return;
      var key = rimKeyFromTireLine(item);
      var sets = mountSetCount(item.quantity);
      byRim[key] = (byRim[key] || 0) + sets;
    });
    return byRim;
  }

  function mountLinesByRim(cart) {
    var lines = {};
    (cart.items || []).forEach(function (item, idx) {
      if (!isAutoMountLine(item)) return;
      var key = rimKeyFromMountLine(item);
      if (!lines[key]) lines[key] = [];
      lines[key].push({ line: idx + 1, qty: item.quantity || 0, variantId: item.variant_id });
    });
    return lines;
  }

  function reloadCartSections() {
    var cartItems =
      document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      return cartItems.onCartUpdate();
    }
    return Promise.resolve();
  }

  function syncMountBalanceFee() {
    if (syncPromise) return syncPromise;

    syncPromise = resolveConfig()
      .then(function (config) {
        if (!config || !config.enabled || !config.fallbackVariantId) return null;

        return fetchCart().then(function (cart) {
          var required = requiredMountByRim(cart);
          var existing = mountLinesByRim(cart);
          var ops = [];

          Object.keys(existing).forEach(function (rimKey) {
            if (required[rimKey]) return;
            existing[rimKey].forEach(function (entry) {
              ops.push(function () {
                return cartChange({ line: entry.line, quantity: 0 });
              });
            });
          });

          Object.keys(required).forEach(function (rimKey) {
            var needQty = required[rimKey];
            var variantId = variantIdForRim(config, rimKey);
            if (!Number.isFinite(variantId) || variantId <= 0) return;

            var rimLines = existing[rimKey] || [];
            var primary = rimLines[0];
            var currentQty = rimLines.reduce(function (sum, e) {
              return sum + (e.qty || 0);
            }, 0);

            rimLines.slice(1).forEach(function (entry) {
              ops.push(function () {
                return cartChange({ line: entry.line, quantity: 0 });
              });
            });

            if (needQty === 0) {
              if (primary) {
                ops.push(function () {
                  return cartChange({ line: primary.line, quantity: 0 });
                });
              }
              return;
            }

            if (!primary) {
              ops.push(function () {
                return cartAdd({
                  items: [
                    {
                      id: variantId,
                      quantity: needQty,
                      properties: {
                        _auto: AUTO_VALUE,
                        _rim: rimKey === 'fallback' ? '' : rimKey,
                      },
                    },
                  ],
                });
              });
              return;
            }

            if (primary.qty !== needQty || primary.variantId !== variantId) {
              if (primary.variantId !== variantId) {
                ops.push(function () {
                  return cartChange({ line: primary.line, quantity: 0 });
                });
                ops.push(function () {
                  return cartAdd({
                    items: [
                      {
                        id: variantId,
                        quantity: needQty,
                        properties: {
                          _auto: AUTO_VALUE,
                          _rim: rimKey === 'fallback' ? '' : rimKey,
                        },
                      },
                    ],
                  });
                });
              } else {
                ops.push(function () {
                  return cartChange({ line: primary.line, quantity: needQty });
                });
              }
            }
          });

          return ops
            .reduce(function (chain, op) {
              return chain.then(function () {
                return op().then(function () {
                  return fetchCart();
                });
              });
            }, Promise.resolve(cart))
            .then(function (finalCart) {
              if (ops.length > 0) return reloadCartSections().then(function () {
                return finalCart;
              });
              return finalCart;
            });
        });
      })
      .finally(function () {
        syncPromise = null;
      });

    return syncPromise;
  }

  window.syncMountBalanceFee = syncMountBalanceFee;

  function onReady() {
    syncMountBalanceFee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      syncMountBalanceFee();
    });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (FORM_IDS.indexOf(form.id) === -1) return;
      var sub = e.submitter;
      if (!sub || sub.getAttribute('name') !== 'checkout') return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      function goCheckout() {
        window.location.href = getCheckoutUrl();
      }

      function runSync(fn) {
        if (typeof fn !== 'function') return Promise.resolve();
        return fn();
      }

      resolveConfig().then(function (config) {
        if (!config || !config.enabled || !config.fallbackVariantId) {
          goCheckout();
          return;
        }
        runSync(window.syncTireRecyclingFee)
          .then(function () {
            return runSync(window.syncMountBalanceFee);
          })
          .then(goCheckout)
          .catch(function (err) {
            console.error(err);
            goCheckout();
          });
      });
    },
    true
  );
})();
